import { DateSettlementLogDto } from "../..";
import {
  formatDateTime,
  formatDateWithDote,
} from "../../../../../../../../utils/date";
import { checkLogType, formatLogType } from "../../utils/log-type";
import {
  MobileSolutionHistoryListItem,
  MobileSolutionHistoryListItemInfo,
  MobileSolutionHistoryListItemWrapper,
  MobileSolutionHistoryListRow,
  MobileSolutionHistoryListWrapper,
  MobileSolutionHistoryRowBorder,
} from "./style";
export interface MobileHistoryListProps {
  list: DateSettlementLogDto[];
  type: string;
}
const MobileSolutionHistoryList = ({ list, type }: MobileHistoryListProps) => {
  return (
    <MobileSolutionHistoryListWrapper>
      {list.map((item, index) => (
        <>
          <MobileSolutionHistoryListRow key={index}>
            <div className="date">
              {formatDateWithDote(item.date, false, false)}
            </div>
            <MobileSolutionHistoryListItemWrapper>
              {item.list.map((log, i) => (
                <MobileSolutionHistoryListItem key={i}>
                  <MobileSolutionHistoryListItemInfo>
                    <div className="info">
                      {log.nickname} <span>-</span> {formatLogType(log.type)}
                    </div>
                    <div className="date">
                      {formatDateTime(log.date.toString())}
                    </div>
                  </MobileSolutionHistoryListItemInfo>
                  <div className="point">
                    {checkLogType(log.type, type)}
                    {log.amount?.toLocaleString()}
                    {type === "SEED" || type === "LEGACY_SEED"
                      ? " RABBIT"
                      : type === "CARROT"
                        ? " CARROT"
                        : " E"}
                  </div>
                </MobileSolutionHistoryListItem>
              ))}
            </MobileSolutionHistoryListItemWrapper>
          </MobileSolutionHistoryListRow>
          <MobileSolutionHistoryRowBorder />
        </>
      ))}
    </MobileSolutionHistoryListWrapper>
  );
};

export default MobileSolutionHistoryList;
